import { Box } from '@mantine/core';
import type { FC } from 'react';
import useQuickHelpContext from '@providers/QuickHelp/useQuickHelpContext';
import type { QuickHelpTab } from '@providers/QuickHelp/types';
import QuickHelpMessages from './QuickHelpMessages';
import QuickHelpInput from './QuickHelpInput';

interface Props {
    tab: QuickHelpTab;
}

const QuickHelpChatArea: FC<Props> = ({ tab }) => {
    const { actions } = useQuickHelpContext();

    const handleSend = (message: string) => {
        void actions.sendMessage(tab.id, message);
    };

    const handleRemoveContext = () => {
        // Clear attached context from this tab
        // (The provider clears it after the first message send, but the user
        //  might want to remove it before sending)
        actions.stagePendingContext({ ...tab.attachedContext! });
        // Trigger a state update to remove context from this specific tab
        // by using the createTab mechanism — simpler to just update via actions
        // For now we expose this through the provider's clearPendingContext
        actions.clearPendingContext();
    };

    return (
        <Box
            style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}
        >
            <QuickHelpMessages messages={tab.messages} statusText={tab.statusText} />
            <QuickHelpInput
                onSend={handleSend}
                isStreaming={tab.isStreaming}
                attachedContext={tab.attachedContext}
                onRemoveContext={handleRemoveContext}
            />
        </Box>
    );
};

export default QuickHelpChatArea;
